export default __webpack_public_path__ + "static/certificate-half-vertical-6ca5069b7d18d89a7a72ba17cbae46e2.png";